/**
 * Constructs a licence number string from the provided licence fields if the licence type is eligible and all fields are populated.
 *
 * @param licenceNumber - An object containing licence fields as key-value pairs (e.g., 'licenceField-1', 'licenceField-2', etc.).
 * @param licenceType - The type of licence, used to determine eligibility for constructing the licence number.
 * @returns The concatenated licence number if the licence type is eligible and all four fields are populated; otherwise, returns an empty string.
 */
export function getLicenceNumber(licenceNumber: Record<string, string>, licenceType: string): string {
	let tempLicence = '';
	const eligibleLicenceTypes = ['F', 'P', 'X', '5'];
	const populatedFields = Object.values(licenceNumber).filter((field) => !!field.length);

	if (eligibleLicenceTypes.includes(licenceType) && populatedFields.length === 4) {
		tempLicence =
			`${licenceNumber['licenceField-1']}` +
			`${licenceNumber['licenceField-2']}` +
			`${licenceNumber['licenceField-3']}` +
			`${licenceNumber['licenceField-4']}`;
	}

	return tempLicence;
}
